import React from 'react'
import { useActions, useValues } from 'kea'
import logic from '../logic'
import I18n from 'lib/i18n'

export default function Questions () {
  const { notFoundKeyword, faqs } = useValues(logic)
  const { setFaqParam } = useActions(logic)

  return (
    <div className='faqs-content'>
      {faqs && faqs.length === 0 ? (
        I18n.t('faqs.index.no_results', { query: notFoundKeyword })
      ) : (
        <ul>
          {faqs.map(faq => (
            <li key={faq.id} style={{ marginBottom: 10 }}>
              <span
                style={{ color: '#75a23b', cursor: 'pointer' }}
                onClick={() => setFaqParam(faq.slug)}
                dangerouslySetInnerHTML={{ __html: faq.highlightTitle }}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
